import { Skeleton } from "@/components/ui/skeleton";
import { REPORT_TABLE_COLUMNS } from "./report-table/report-table-columns";

const REPORT_SKELETON_ROW_COUNT = 4;
const NAV_SKELETON_ROW_COUNT = 3;

/** Stands in for the item sections between Overview and Run history. Same
 * padding and border classes as the nav's buttons so the real rows replace
 * them without shifting the menu. */
export function SectionNavSkeletonRows() {
  return Array.from({ length: NAV_SKELETON_ROW_COUNT }, (_, index) => (
    <div
      key={index}
      aria-hidden
      className="flex items-center justify-between gap-3 border-b-2 border-transparent px-4 py-3 lg:border-b-0 lg:border-l-2"
    >
      <Skeleton className="h-5 w-20" />
      <Skeleton className="size-4 shrink-0 rounded-full" />
    </div>
  ));
}

/** Mirrors the loaded section: heading, tally badge and items table. On
 * narrow screens the table stacks every cell but the chevron, so the
 * skeleton does too and its rows keep the loaded height. */
export function VerificationReportSkeleton() {
  return (
    <div role="status" aria-busy="true" className="space-y-4">
      <span className="sr-only">Loading verification report…</span>
      <div
        aria-hidden
        className="flex flex-wrap items-start justify-between gap-3"
      >
        <div className="space-y-1">
          <Skeleton className="h-7 w-48" />
          <Skeleton className="h-5 w-72 max-w-full" />
        </div>
        <Skeleton className="h-7 w-32 rounded-full" />
      </div>
      <div
        aria-hidden
        className="overflow-hidden rounded-lg border bg-background"
      >
        <div className="hidden h-9 border-b bg-muted/40 sm:block" />
        {Array.from({ length: REPORT_SKELETON_ROW_COUNT }, (_, index) => (
          <div
            key={index}
            className={`grid items-center gap-x-4 gap-y-1.5 border-b px-4 py-3 last:border-b-0 ${REPORT_TABLE_COLUMNS}`}
          >
            <div className="space-y-1.5">
              <Skeleton className="h-5 w-3/4" />
              <Skeleton className="h-4 w-1/2" />
            </div>
            <Skeleton className="h-6 w-24 rounded-full" />
            <Skeleton className="h-5 w-20" />
            <Skeleton className="h-4 w-24" />
            <Skeleton className="h-5 w-28" />
            <Skeleton className="hidden size-4 sm:block" />
          </div>
        ))}
      </div>
    </div>
  );
}
